import {MenuGroup} from "@atlaskit/menu";
import type {ComponentProps} from "react";

export function AnankeMenuButtonGroup(props: ComponentProps<typeof MenuGroup>) {
    return <MenuGroup {...props} />;
}
